import React from 'react';

const SvgSpotify = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    width="17"
    height="16"
    viewBox="0 0 17 16"
    fill="none"
    {...props}
  >
    <path
      d="M8.5 0C4.08 0 .5 3.58.5 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8Zm3.67 11.54a.5.5 0 0 1-.69.17c-1.88-1.15-4.25-1.41-7.04-.77a.5.5 0 1 1-.22-.97c3.05-.7 5.67-.4 7.78.89a.5.5 0 0 1 .17.69Zm.98-2.18a.62.62 0 0 1-.86.21c-2.15-1.32-5.43-1.71-7.98-.93a.62.62 0 1 1-.36-1.19c2.91-.89 6.53-.46 8.99 1.06a.62.62 0 0 1 .21.86Zm.09-2.26c-2.58-1.53-6.84-1.67-9.3-.92a.75.75 0 1 1-.43-1.43c2.83-.86 7.53-.69 10.5 1.07a.75.75 0 1 1-.77 1.28Z"
      fill="currentColor"
    />
  </svg>
);

export default SvgSpotify;
